import { dataSourceItem } from "../../redux/models/reduxModels";
import { IDropdownOption } from "@fluentui/react";
import { DatasourceService } from "../../services/DatasourceService";

export class dataSourceDropdownBinder {
  constructor(
    private datesourceService: DatasourceService,
    private datasource: dataSourceItem,
    private displayName: string
  ) { }

  getDatasourceEntries = async () => {
    const result = await this.datesourceService.GetData({
      id: this.datasource.id,
      tenantId: this.datasource.tenantId,
      typeId: this.datasource.type.id,
      typeName: this.datasource.type.name,
      name: this.datasource.name,
      queryParams: [{ name: this.getDataSourcePropertyToBindTo(), value: "" }],
      returnOnlyQueriedProperties: true,
      allowCache: this.datasource.allowCache
    });

    return result;
  };

  getDataSourcePropertyToBindTo = () => {
    const boundedField = this.datasource && this.datasource.boundFields?.find(item => item?.name?.split(",").some(name => name?.trim().toLowerCase() === this.displayName?.trim().toLowerCase()));
    return boundedField?.datasourceField ? boundedField.datasourceField.trim() : boundedField?.name?.trim();
  };

  bindDataSourceToDropdown = (data: any[], property: string): IDropdownOption[] => {
    if (data?.length > 0) {
      const mappedPropertyKey: string = Object.keys(data[0])?.find(key => key.toLowerCase().trim() == property.toLowerCase().trim());
      if (mappedPropertyKey) {
        // Set rather than the `a.findIndex(t => t.key === v.key) === i` this replaces, which was
        // O(n²) over the WHOLE datasource. This binder is fed by Data(), so the handlers' show-all
        // guards do not bound it: a corpus at Exact's maxRows ceiling of 50 000 put ~1.25e9 string
        // comparisons on the UI thread every time a dropdown mounted.
        //
        // Keyed on the RAW value, exactly as findIndex compared it. Exact's Code carries 18-char
        // left padding and this binder deliberately does not trim it (the option key is what gets
        // stored), so de-duplicating on a trimmed key would merge options that stay distinct.
        const seen: Set<string> = new Set<string>();
        const options: IDropdownOption[] = [];
        for (const item of data) {
          const value = item[mappedPropertyKey];
          if (!(value?.trim().length > 0) || seen.has(value)) {
            continue;
          }
          seen.add(value);
          options.push({ key: value, text: value });
        }
        return options
          .sort((a, b) => (a.key as string).toUpperCase().trim() < (b.key as string).toUpperCase().trim() ? -1 : 1);
      }
    }
    return [];
  };
}